// Class: starling.animation.IAnimatable

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IAnimatable = function() {}

// Meta

IAnimatable.__name__ = "starling.animation.IAnimatable";
IAnimatable.__isInterface__ = true;
IAnimatable.prototype = {
	
};
IAnimatable.prototype.__class__ = IAnimatable.prototype.constructor = $hxClasses["starling.animation.IAnimatable"] = IAnimatable;

// Init



// Statics




// Export

exports.default = IAnimatable;